import { SparklesIcon } from "@heroicons/react/24/outline";
import { FC } from "react";

interface Status {
  id: number;
  value: string;
}
interface Props {
  status: Status;
  className?: string;
}

const ProductStatus: FC<Props> = ({
  status,
  className = "absolute top-3 left-3 px-2.5 py-1.5 text-xs bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-300",
}) => {
  const renderStatus = () => {
    const CLASSES = `nc-shadow-lg rounded-full flex items-center justify-center ${className}`;
    if (status && status.id != 5)
      return (
        <div className={CLASSES}>
          <SparklesIcon className="w-3.5 h-3.5" />
          <span className="ml-1 leading-none">{status.value}</span>
        </div>
      );

    return null;
  };

  return renderStatus();
};

export default ProductStatus;
